export default __webpack_public_path__ + "static/media/United Kingdom.1c2fbca1.svg";